import { motion } from 'framer-motion'
import { SectionWrapper, Button } from '../components/primitives/index.js'
import { useProducts } from '../context/ProductsContext.jsx'
import './CTA.css'

/** Field names mirror Prod's CTA.jsx CTA_DEFAULTS — see siteContent.cta. */
const CTA_DEFAULTS = {
  eyebrow: 'Begin your research',
  headLine1: 'Ready to start',
  headLine2: 'your research?',
  body: 'Browse the full catalog — every compound cold-shipped with a certificate of analysis.',
  buttonText: 'Shop the catalog',
  buttonLink: '/catalog',
  disclaimer: 'For research purposes only · Not FDA approved · Not for human use - *Dispatch time is an estimate and may vary',
}

const STATS = [
  { value: '99%+', label: 'Verified purity' },
  { value: '2,000+', label: 'Researchers served' },
  { value: '24H*', label: 'Dispatch time' },
]

export default function CTA() {
  const { siteContent } = useProducts()
  const c = { ...CTA_DEFAULTS, ...(siteContent?.cta ?? {}) }
  const stats = siteContent?.cta?.stats?.length ? siteContent.cta.stats : STATS

  return (
    <SectionWrapper id="cta" className="cta container">
      <div className="cta__console">
        <span className="cta__corner cta__corner--tl" aria-hidden="true" />
        <span className="cta__corner cta__corner--tr" aria-hidden="true" />
        <span className="cta__corner cta__corner--bl" aria-hidden="true" />
        <span className="cta__corner cta__corner--br" aria-hidden="true" />

        <div className="cta__main">
          <span className="cta__status">
            <motion.span
              className="cta__status-dot"
              animate={{ opacity: [1, 0.25, 1] }}
              transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
              aria-hidden="true"
            />
            {c.eyebrow}
          </span>

          <h2 className="cta__headline">
            {c.headLine1}
            <br />
            {c.headLine2}
          </h2>

          <p className="cta__body">{c.body}</p>

          <div className="cta__actions">
            <Button to={c.buttonLink} variant="primary" size="lg" className="cta__button">
              <span className="cta__prompt" aria-hidden="true">
                &gt;_
              </span>
              {c.buttonText}
            </Button>
          </div>

          <span className="cta__disclaimer">{c.disclaimer}</span>
        </div>

        <div className="cta__stats">
          {stats.map((s, i) => (
            <div className="cta__stat" key={s.label}>
              <span className="cta__stat-index">{String(i + 1).padStart(2, '0')}</span>
              <span className="cta__stat-value">{s.value}</span>
              <span className="cta__stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </SectionWrapper>
  )
}
